// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IEmployeeRoleUpdateDto
 */
export interface IEmployeeRoleUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof IEmployeeRoleUpdateDto
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeRoleUpdateDto
     */
    role: IEmployeeRoleUpdateDtoRoleEnum;
    /**
     * 
     * @type {string}
     * @memberof IEmployeeRoleUpdateDto
     */
    source_entry_point?: string;
}

/**
* @export
* @enum {string}
*/
export enum IEmployeeRoleUpdateDtoRoleEnum {
    DEPENDENT = 'DEPENDENT',
    EMPLOYEE = 'EMPLOYEE',
    EMPLOYEE_LIMITED_ACCESS = 'EMPLOYEE_LIMITED_ACCESS',
    TECH_USER = 'TECH_USER',
    PARTNER_USER = 'PARTNER_USER',
    CUSTOM_ADMIN = 'CUSTOM_ADMIN',
    NO_ACCESS = 'NO_ACCESS'
}


/**
 * Check if a given object implements the IEmployeeRoleUpdateDto interface.
 */
export function instanceOfIEmployeeRoleUpdateDto(value: object): value is IEmployeeRoleUpdateDto {
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function IEmployeeRoleUpdateDtoFromJSON(json: any): IEmployeeRoleUpdateDto {
    return IEmployeeRoleUpdateDtoFromJSONTyped(json, false);
}

export function IEmployeeRoleUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IEmployeeRoleUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'],
        'role': json['role'],
        'source_entry_point': json['source_entry_point'] == null ? undefined : json['source_entry_point'],
    };
}

export function IEmployeeRoleUpdateDtoToJSON(json: any): IEmployeeRoleUpdateDto {
    return IEmployeeRoleUpdateDtoToJSONTyped(json, false);
}

export function IEmployeeRoleUpdateDtoToJSONTyped(value?: IEmployeeRoleUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'role': value['role'],
        'source_entry_point': value['source_entry_point'],
    };
}

